import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './civilian/HeroSection';
import { UpcomingClasses } from './civilian/UpcomingClasses';
import { EmpoweringSection } from './civilian/EmpoweringSection';
import { CtaSection } from './civilian/CtaSection';
export function CivilianPage() {
  return <div className="min-h-screen flex flex-col bg-brand-black" data-id="element-313">
      <Navbar data-id="element-314" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-315">
        <HeroSection data-id="element-316" />
        <UpcomingClasses data-id="element-317" />
        <EmpoweringSection data-id="element-318" />
        <CtaSection data-id="element-319" />
      </main>
      <Footer data-id="element-320" />
    </div>;
}